import _asyncToGenerator from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { Message, MessageBox } from 'element-ui'; // const Message = require('element-ui')

import util from '@/libs/util.js';
import router from '@/router';
import { AccountLogin } from '@api/sys.login';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var dispatch = _ref.dispatch;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$username = _ref2.username,
          username = _ref2$username === void 0 ? '' : _ref2$username,
          _ref2$password = _ref2.password,
          password = _ref2$password === void 0 ? '' : _ref2$password,
          _ref2$captcha = _ref2.captcha,
          captcha = _ref2$captcha === void 0 ? '' : _ref2$captcha;

      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountLogin({
          username: username,
          password: password,
          captcha: captcha
        }).then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                    // 整个系统依赖这两个数据进行校验和存储
                    // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                    // token 代表用户当前登录状态
                    util.cookies.set('uuid', res.uuid);
                    util.cookies.set('username', res.username);
                    util.cookies.set('token', res.token); // 设置 vuex 用户信息

                    _context.next = 5;
                    return dispatch('u8sdk/user/set', {
                      id: res.uuid,
                      name: res.username,
                      roleId: res.roleId,
                      email: res.email
                    }, {
                      root: true
                    });

                  case 5:
                    _context.next = 7;
                    return dispatch('load');

                  case 7:
                    // 结束
                    resolve();

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (err) {
          console.log('err: ', err);
          reject(err);
        });
      });
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$confirm = _ref5.confirm,
          confirm = _ref5$confirm === void 0 ? false : _ref5$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove('token');
                  util.cookies.remove('uuid');
                  util.cookies.remove('username'); // 清空 vuex 用户信息

                  _context2.next = 5;
                  return dispatch('u8sdk/user/set', {}, {
                    root: true
                  });

                case 5:
                  // 跳转路由
                  router.push({
                    name: 'login'
                  });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          logout();
        }).catch(function () {
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref6) {
      var dispatch = _ref6.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return dispatch('u8sdk/user/load', null, {
                    root: true
                  });

                case 2:
                  _context3.next = 4;
                  return dispatch('u8sdk/theme/load', null, {
                    root: true
                  });

                case 4:
                  _context3.next = 6;
                  return dispatch('u8sdk/menu/collapseLoad', null, {
                    root: true
                  });

                case 6:
                  _context3.next = 8;
                  return dispatch('u8sdk/menu/fetchMenus', null, {
                    root: true
                  });

                case 8:
                  resolve();

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  }
};